/**
 * SearchResultListItem
 * TODO: Someting is not correct with the spacing around the heading
 */
import React from 'react';
import { Link as LinkBase } from 'ui-component-library/base';
/** Naviagation list with links. */
var SearchResultListItem = function (_a) {
    var category = _a.category, heading = _a.heading, text = _a.text, _b = _a.url, url = _b === void 0 ? '#' : _b, _c = _a.headingLevel, headingLevel = _c === void 0 ? 'h1' : _c, _d = _a.LinkComponent, LinkComponent = _d === void 0 ? LinkBase : _d, _e = _a.icon, icon = _e === void 0 ? 'arrow' : _e;
    var Link = LinkComponent;
    var Heading = headingLevel;
    return (React.createElement("article", { "data-cid": "SearchResultListItem" },
        React.createElement(Link, { to: url, className: "block pb-6 mb-6 no-underline border-b-2 border-greyLight group" },
            category && React.createElement("p", { className: "text-p text-greyDarker" }, category),
            React.createElement("header", { className: "flex justify-between" },
                React.createElement(Heading, { className: "mb-1 text-h2 text-teal group-hover:underline" }, heading)),
            React.createElement("p", { className: "text-p text-black lg:text-p" }, text))));
};
export default SearchResultListItem;
